var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H513V341.961H0V-0.00585938Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 -0.00585938V117.623H210.31L256.5 148.383V171.028H233.856L160.312 122.032V171.028H96.1875V122.032L22.6441 171.028H0V148.383L46.19 117.623H0V53.4984H46.19L0 22.7385V-0.00585938H22.6441L96.1875 48.9897V-0.00585938H160.312V48.9897L233.856 -0.00585938H256.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.281 -0.00585938H112.219V69.5297H0V101.592H112.219V171.028H144.281V101.592H256.5V69.5297H144.281V-0.00585938Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 22.7385V53.4985H210.31L256.5 22.7385Z",
    fill: "#2E52B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 171.027V160.006L62.6221 117.623H85.2662L7.31426 171.027H0ZM7.31426 0.0941162L85.2662 53.398H62.6221L0 11.1156V0.0941162H7.31426ZM256.5 0.0941162V11.1156L193.878 53.4982H171.234L249.186 0.0941162H256.5ZM249.186 171.027L171.234 117.623H193.878L256.5 160.006V171.027H249.186Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.266 277.635C460.314 277.635 473.323 258.122 473.323 234.05C473.323 209.979 460.314 190.465 444.266 190.465C428.219 190.465 415.209 209.979 415.209 234.05C415.209 258.122 428.219 277.635 444.266 277.635Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.695 327.633C419.869 327.633 429.738 323.461 429.738 318.315C429.738 313.168 419.869 308.996 407.695 308.996C395.521 308.996 385.652 313.168 385.652 318.315C385.652 323.461 395.521 327.633 407.695 327.633Z",
    fill: "#FFCE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.711 327.633C376.885 327.633 386.754 323.461 386.754 318.315C386.754 313.168 376.885 308.996 364.711 308.996C352.537 308.996 342.668 313.168 342.668 318.315C342.668 323.461 352.537 327.633 364.711 327.633Z",
    fill: "#FFCE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.668 190.465L386.153 277.535L429.738 190.465H342.668Z",
    fill: "#39B200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.14 277.635C344.187 277.635 357.196 258.122 357.196 234.05C357.196 209.979 344.187 190.465 328.14 190.465C312.092 190.465 299.083 209.979 299.083 234.05C299.083 258.122 312.092 277.635 328.14 277.635Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.725 175.937L357.196 190.465H415.209L400.681 175.937L415.209 132.352C415.209 132.352 402.184 103.296 386.153 103.296C370.122 103.296 357.096 132.352 357.096 132.352L371.725 175.937Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.153 96.1816C402.2 96.1816 415.209 83.1725 415.209 67.125C415.209 51.0775 402.2 38.0684 386.153 38.0684C370.105 38.0684 357.096 51.0775 357.096 67.125C357.096 83.1725 370.105 96.1816 386.153 96.1816Z",
    fill: "#C6B56F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.754 117.924C402.801 117.924 415.811 104.915 415.811 88.8674C415.811 72.8199 402.801 59.8108 386.754 59.8108C370.706 59.8108 357.697 72.8199 357.697 88.8674C357.697 104.915 370.706 117.924 386.754 117.924Z",
    fill: "#A54A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.266 146.981C460.314 146.981 473.323 133.972 473.323 117.924C473.323 101.877 460.314 88.8674 444.266 88.8674C428.219 88.8674 415.209 101.877 415.209 117.924C415.209 133.972 428.219 146.981 444.266 146.981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.868 176.037C358.916 176.037 371.925 163.028 371.925 146.981C371.925 130.933 358.916 117.924 342.868 117.924C326.821 117.924 313.812 130.933 313.812 146.981C313.812 163.028 326.821 176.037 342.868 176.037Z",
    fill: "#0049FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.639 176.037C446.687 176.037 459.696 163.028 459.696 146.981C459.696 130.933 446.687 117.924 430.639 117.924C414.592 117.924 401.583 130.933 401.583 146.981C401.583 163.028 414.592 176.037 430.639 176.037Z",
    fill: "#0041F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.754 263.107C402.801 263.107 415.811 250.098 415.811 234.05C415.811 218.003 402.801 204.994 386.754 204.994C370.706 204.994 357.697 218.003 357.697 234.05C357.697 250.098 370.706 263.107 386.754 263.107Z",
    fill: "#F7D71E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.794 219.522C474.842 219.522 487.851 206.513 487.851 190.465C487.851 174.418 474.842 161.409 458.794 161.409C442.747 161.409 429.738 174.418 429.738 190.465C429.738 206.513 442.747 219.522 458.794 219.522Z",
    fill: "#CEC851"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.153 319.116C402.2 319.116 415.209 306.107 415.209 290.06C415.209 274.012 402.2 261.003 386.153 261.003C370.105 261.003 357.096 274.012 357.096 290.06C357.096 306.107 370.105 319.116 386.153 319.116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.725 135.959L386.253 132.452L400.781 135.959C400.781 143.474 386.253 146.981 386.253 146.981C386.253 146.981 371.725 143.474 371.725 135.959Z",
    fill: "#7C0B29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.14 146.68C344.187 146.68 357.196 133.671 357.196 117.623C357.196 101.576 344.187 88.5668 328.14 88.5668C312.092 88.5668 299.083 101.576 299.083 117.623C299.083 133.671 312.092 146.68 328.14 146.68Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 341.967,
    fill: "white",
    transform: "translate(0 -0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGs);
export default __webpack_public_path__ + "static/media/GS.13af274ee5d474ed674c52372f873b19.svg";
export { ForwardRef as ReactComponent };